import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import surf from "../../images/News/Surf.png"
import pt from "../../images/News/Pt.png"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";

function SurfNews () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <a style={{alignSelf: "end"}} href={surf} download>
                    <i style={{fontSize: "2em", color: "grey", marginRight: "0.5em"}} className="bi bi-download"></i>
                </a>
                <img src={surf} style={{width: "100%"}}></img>
            </div>
            <Space />

        </div>
    )
}
export default SurfNews